/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.25.1
 */

import styled, { css } from 'styled-components';

import { colors } from '@/main/theme';

interface INewsItemContainerStyledProps {
    $selected: boolean;
}

export const NewsListContainerStyled = styled.div`
    height: 100%;
    padding: 24px 24px 0 0;
    border-right: 1px solid ${colors.borderColorDisabled};
`;

export const NewsListWrapperStyled = styled.ul`
    display: flex;
    flex-direction: column;
    list-style: none;
    margin: 0;
    padding: 0;

    & > :not(:last-child) {
        margin-bottom: 16px;
    }
`;

export const NewsItemContainerStyled = styled.li<INewsItemContainerStyledProps>`
    width: 100%;

    & .link,
    .link-block__link {
        ${(props) => {
            if (props.$selected) {
                return css`
                    font-weight: 600;
                    color: ${colors.textColor};
                    pointer-events: none;
                    cursor: default;
                    text-decoration: none;
                `;
            }
        }}
    }
`;
